<template>
    <div class="shareList">
       <van-list v-model="loading" :finished="finished" :immediate-check="false" @load="onLoad" >
          <div class="hiabao_list">
            <div class="img_box" v-for="(item,idx) in list" :key='idx'>
              <img :src="item.preview_url" alt  @click="seeBigImg(item.down_url)"/>
              <p class="text">海报生成中</p>
            </div>
          </div>
       </van-list>

      <div class="empty_null" v-if="list.length==0">
          <img  src="https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/installMall/home_new/null_datay.png" alt=""/>
          <p>暂无海报</p>
      </div>

        <van-popup v-model="showpop" position="bottom">
          <div class="img_hezi">
            <img  class="imgtu" :src="imgurl" alt=""/>
            <p>长按图片保存</p>
            <p class="close_p" @click="guanbi"> <qdd-icon class="iconquxiao" color="#fff" size="1.2rem" @click="closePoster"></qdd-icon></p>
          </div>
        </van-popup>
    </div>
</template>
<script>
    import icon from '@/components/iconfont';
    import { sendRequest } from '@/assets/public'
    export default {
        components: {
            'qdd-icon': icon,
        },
        data(){
            return{
              list:[],
              page:1,
              showpop: false, //弹框
              imgurl:'',
              loading: false,
              finished: false,
            }
        },
        mounted() {
            this.getStoreShare()
             window.scrollTo(0, 0)
        },
        methods:{
              //滚动加载时触发，list组件定义的方法
              onLoad() {
                this.page++
                this.getStoreShare()
              },
              async getStoreShare() {
                let res = await sendRequest('user/storeShare', {
                    type:'0',
                    page: this.page,
                    limit: 5,
                  })
                this.showLoading = false
                if (res.status == 200) {
                    this.list=this.list.concat(...res.content);
                    this.loading = false
                    this.finished = res.content.length == 0
                    console.log(this.list,'=oooo')
                }
               
              },

              seeBigImg(imgurl){
                console.log(imgurl)
                this.showpop=true
                this.imgurl=imgurl
              },
              guanbi(){
                this.showpop=false
              }
        }
    }
</script>

<style scoped>
.hiabao_list {
    width: 14.2rem;
    margin: 0 auto;
    display: flex;
    flex-flow: wrap;
    justify-content: space-between;
    padding-bottom: 4rem;
}

.img_box{
   width: 6.9rem;
    height: 9.56rem;
    margin-top: 0.4rem;
    border-radius: 0.4rem;
    position: relative;
    background: rgba(255, 255, 255, 0.6);
}
.img_box img{
    width: 100%;
    border-radius: 0.4rem;
    position: absolute;
    top: 0;
    left: 0;
}
.text{
    text-align: center;
    font-size: 0.8rem;
    width:  6.9rem;
    display: inline-block;
    padding-top: 4rem;
    color: #ddd;
}


.empty_null{
    text-align: center;
   width: 100%;
   background: #fff;
  height: 14rem;
   border-radius:0.4rem;
   }
  .empty_null img{
   width: 6.4rem;
   height: 6.4rem;;
  }
  .empty_null p{
   display: block;
   font-size: 0.56rem;
   color: #969799;
   line-height: 0.8rem
  }
  .imgtu{
    width: 13.8rem;
    height:19.12rem;
  
  }
  .img_hezi{
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 13.8rem;
    text-align: center;

  }
  .img_hezi p{
    text-align: center;
    font-size: 0.6rem;
    color: #fff;
    padding-top: 0.4rem;
  }
  .close_p{
     font-size: 0.56rem !important;
  }
</style>
